export interface TimelineItemData {
  id: string;
  date?: string;
  title: string;
  description?: string;
}

export interface TimelineData {
  title: string;
  items: TimelineItemData[];
}

export function parseTimelineBlock(jsonStr: string): TimelineData | null {
  try {
    const raw = JSON.parse(jsonStr);

    if (
      typeof raw.title !== "string" ||
      !Array.isArray(raw.items) ||
      raw.items.length === 0
    )
      return null;

    // Validate each item has at least id and title
    for (const item of raw.items) {
      if (typeof item.id !== "string" || typeof item.title !== "string")
        return null;
    }

    return {
      title: raw.title,
      items: raw.items,
    };
  } catch {
    return null;
  }
}
